import { Button, Tooltip } from 'antd'
import { BarsOutlined, MinusOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../auth'

const STORAGE_KEY = 'showCandidateAttributes'

export function attributesVisible() {
    return localStorage.getItem(STORAGE_KEY) === 'true'
}

export function CandidateAttributesToggle() {
    const { t } = useTranslation()

    const { showCandidateAttributes, setShowCandidateAttributes } = useAuth()

    return (
        <Tooltip title={showCandidateAttributes ? t('Hide candidate attributes') : t('Show candidate attributes')}>
            <Button
                type="text"
                onClick={() => {
                    localStorage.setItem(STORAGE_KEY, `${!showCandidateAttributes}`)
                    setShowCandidateAttributes(!showCandidateAttributes)
                }}
                icon={showCandidateAttributes ? <MinusOutlined /> : <BarsOutlined />}
            />
        </Tooltip>
    )
}
